 <div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <h4 class="personal-details-title">Modify Plan</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Plan Name</th>
              <th scope="col">Plan Group</th>
              <th scope="col">Plan Heading</th>
              <th scope="col">Plan SubHeading</th>
              <th scope="col">Plan Amount</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of planData; let i=index">
              <th scope="col" >{{plan.name}}</th>
              <th scope="col" >{{plan.group}}</th>
              <th scope="col" >{{plan.planHeading}}</th>
              <th scope="col" >{{plan.planSubHeading}}</th>
              <th scope="col" >{{plan.planAmount}}</th>
              <th>
                <i (click)="getPlanById(plan.planInfoId)" data-toggle="modal" data-target="#updateTemplate" class="bi bi-pencil-square"></i>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="updateTemplate" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Plan
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>Select Service <span class="required-field">*</span></label>
                <select [(ngModel)]="singlePlanData.serviceId" class="form-control">
                  <option value="{{service.serviceId}}" *ngFor="let service of serviceData">
                    {{service.name}}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Name <span class="required-field">*</span></label>
                  <input [(ngModel)]="singlePlanData.name" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Group</label>
                  <input [(ngModel)]="singlePlanData.group" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Heading <span class="required-field">*</span></label>
                  <input [(ngModel)]="singlePlanData.planHeading" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Sub Heading <span class="required-field">*</span></label>
                <input [(ngModel)]="singlePlanData.planSubHeading" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>Plan Amount <span class="required-field">*</span></label>
                    <input [(ngModel)]="singlePlanData.planAmount" type="number" class="form-control">
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>Tax Included </label>
                    <select name="" id="" [(ngModel)]="singlePlanData.taxIncluded" class="form-control">
                      <option value="true">Included</option>
                      <option value="false" selected>Not Included</option>
                    </select>
                  </div>
                </div>
              </div>
             
              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>Tax Percentage </label>
                    <input [(ngModel)]="singlePlanData.taxPercentage" type="number" class="form-control">
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Plan InfoType</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.planInfoType" class="form-control">
                        <option value="POSTPAID">POSTPAID</option>
                        <option value="PREPAID">PREPAID</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Add On Plan</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.addonPlan" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Publicly Visible</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.isPubliclyVisible" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              
             
            </div>
            <div class="row">
              <h5 class="lab-h">Plan Details</h5>
                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of singlePlanData.planKeyValue;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="singlePlanData.planKeyValue[i].key">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" placeholder="enter value" [(ngModel)]="singlePlanData.planKeyValue[i].value[j]">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addi(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removeValue(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeProd(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeProd(i)">remove</button>
                      <button (click)="addP()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>

                <h5 class="lab-h">Integration Details</h5>

                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of singlePlanData.integrationKeyValue;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="singlePlanData.integrationKeyValue[i].key">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" placeholder="enter value" [(ngModel)]="singlePlanData.integrationKeyValue[i].value[j]">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addintegration(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removevintegration(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeintegration(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeintegration(i)">remove</button>
                      <button (click)="addvintegration()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>
            </div>

            <h5 class="lab-h">Charge Details</h5>
            <div class="col-md-12 col-lg-12" class="chargeDetail">
              <div>
                <div class="chargeDetail-fields" *ngFor="let change of singlePlanData.chargeDetail;let i = index;let last = last">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeHeading" placeholder="enter charge heading">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeName" placeholder="enter charge name">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeAmount" placeholder="enter amount">
                  <select name="" id="" [(ngModel)]="singlePlanData.chargeDetail[i].chargeType">
                    <option value="select type" selected disabled>select type</option>
                    <option value="NRC">NRC</option>
                    <option value="RC">RC</option>
                    <option value="UC">UC</option>
                  </select>
                  <i class="bi bi-plus-circle" *ngIf="last" (click)="addChargeDetail()"></i>
                  <i class="bi bi-dash-circle" (click)="removeChargeDetail(i)" *ngIf="!last"></i>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">Cancel</button>
              <button type="button" (click)="updatePlan()" class="btn btn-primary">Add Plan</button>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</div>